module.exports = __webpack_public_path__ + "static/media/StrongHer.1060e28f.webp";